import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Avatar, Button, Container, CssBaseline, Link, TextField, Typography } from "@material-ui/core";
import { LockOpenOutlined } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: { width: "100%", marginTop: theme.spacing(2) },
  submit: { margin: theme.spacing(3, 0, 2) },
}));

const ForgotPassword = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Revisá tu correo para continuar.");
    } catch (error) {
      toastError(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}><LockOpenOutlined /></Avatar>
        <Typography component="h1" variant="h5">Recuperar contraseña</Typography>
        {sent ? (
          <>
            <Typography align="center" color="textSecondary" style={{ marginTop: 24 }}>
              Si el correo está registrado, recibirás un enlace válido durante 30 minutos.
            </Typography>
            <Link component={RouterLink} to="/login" style={{ marginTop: 24 }}>
              Volver a iniciar sesión
            </Link>
          </>
        ) : (
          <form className={classes.form} onSubmit={handleSubmit}>
            <Typography color="textSecondary">
              Ingresá el correo de tu cuenta y te enviaremos un enlace seguro.
            </Typography>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="recovery-email"
              label="Correo electrónico"
              name="email"
              type="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={event => setEmail(event.target.value)}
            />
            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit} disabled={submitting}>
              {submitting ? "Enviando…" : "Enviar enlace"}
            </Button>
            <Link component={RouterLink} to="/login" variant="body2">Volver a iniciar sesión</Link>
          </form>
        )}
      </div>
    </Container>
  );
};

export default ForgotPassword;
